import { SET_ALL_ANSWERS, SET_ALL_DATA, SET_ANSWER, SET_FLOW_STATUS, UPDATE_AND_CLEAR_MARITAL } from '../actions/userData';
import { updateMaritalAnswerAndClearOldAnswers } from '../components/flows/changeHandlers/maritalStatusChangeHandler';

function getDefaultState() {
    return {
        answers: {},
        flows: {}
    };
}

const userData = (state = getDefaultState(), action) => {
    switch (action.type) {
        case SET_ANSWER:
            let newAnswers = { ...state.answers };
            newAnswers[action.answerKey] = action.answerValue;
            return {
                ...state,
                answers: newAnswers
            };
        case SET_ALL_ANSWERS:
            return {
                ...state,
                answers: action.newAnswers
            };
        case SET_FLOW_STATUS:
            return {
                ...state,
                flows: {
                    ...state.flows,
                    [action.name]: action.status
                }
            };
        case UPDATE_AND_CLEAR_MARITAL:
            return {
                ...state,
                answers: updateMaritalAnswerAndClearOldAnswers(action.newAnswer, state.answers)
            };
        case SET_ALL_DATA:
            return {
                ...action.data
            }
        default:
            return state;
    }
}

export default userData;